const Data = [
    {
        name: "Annual Wonderland ",
        address: "83 Victoria Street, London, SW1H 0HW.",
        ph: "(257) 563-7401",
        date: "September 14, 2022",
        price: "48$",
        rating: "4",
        image: "https://img.freepik.com/free-photo/cute-young-girl-with-dark-wavy-hairstyle-bright-makeup-silk-dress-black-jacket-holding-sunglasses-hands-looking-away-against-beige-building-wall_197531-24462.jpg?t=st=1652688166~exp=1652688766~hmac=45ed7d4554fba27f98d1886377980c60d8f015ebdfdd9375999f3333456e77d5&w=740"
    },
    {
        name: "Boogie Horizon  ",
        address: "40 Bowling Green, London, EC1R 0NE",
        ph: "(372) 587-2335",
        date: "April 19, 2022",
        price: "60$",
        rating: "5",
        image: "https://img.freepik.com/free-photo/blissful-young-lady-sunglasses-fooling-around-during-photoshoot-chair-laughing-winsome-girl-white-shoes_197531-5165.jpg?t=st=1652688166~exp=1652688766~hmac=e8f57e8e00a2c47a2a3eebdde632134274d7a577d85623e6c2c8fa0cba32226d&w=740"
    },
    {
        name: "Boogie Paradise  ",
        address: "Cecilia Chapman 711-2880 Nulla St.Mankato Mississippi 96522",
        ph: "(786) 713-8616",
        date: "November 18, 2023",
        price: "20$",
        rating: "4",
        image: "https://img.freepik.com/free-photo/trendy-attractive-woman-with-wavy-hairstyle-with-modern-cool-earrings-big-red-lips-green-sundress-looking-into-camera_197531-23999.jpg?t=st=1652688166~exp=1652688766~hmac=837d60ac016c70f1b527d37220a665fe0da9d7e5b524f223d7aab29d978f264a&w=740"
    },

    {
        name: "Dance Paradise  ",
        address: "Iris Watson P.O. Box 283 8562 Fusce Rd. Frederick Nebraska 20620",
        ph: "(793) 151-6230",
        date: "December 09, 2022",
        price: "40$",
        rating: "3",
        image: "https://img.freepik.com/free-photo/successful-business-woman_1328-2309.jpg?t=st=1652688166~exp=1652688766~hmac=0cff9e005b45dd75942246850dabbb7b0ebb34656b7665d2f873cbd452a57e62&w=740"
    },

    {
        name: "Festival Oasis  ",
        address: "Celeste Slater 606-3727 Ullamcorper. Street Roseville NH 11523",
        ph: "(492) 709-6392",
        date: "March 21, 2023",
        price: "38$",
        rating: "5",
        image: "https://img.freepik.com/free-photo/charming-woman-with-curly-hairstyle-make-up-studio_7502-8928.jpg?t=st=1652688461~exp=1652689061~hmac=f47204abd0c0cdbabc3510d628e43ec02302382e8f971a5cfcab3a4911e67d4a&w=740"
    },

    {
        name: "Fest Invasion ",
        address: "Theodore Lowe Ap #867-859 Sit Rd. Azusa New York 39531",
        ph: "(654) 393-5734",
        date: "April 30, 2022",
        price: "87$",
        rating: "4",
        image: "https://img.freepik.com/free-photo/beautiful-girl-stands-near-walll-with-leaves_8353-5378.jpg?t=st=1652688461~exp=1652689061~hmac=fae67000bbb68cb1b20c7416f6861750d26a8a91575e07a27637355a84ff54ca&w=740"
    },

    {
        name: "Fest Kingdom ",
        address: "Calista Wise 7292 Dictum Av. San Antonio MI 47096",
        ph: "(404) 960-3807",
        date: "September 09, 2022",
        price: "81$",
        rating: "3",
        image: "https://img.freepik.com/free-photo/cute-girl-with-shopping-bag-city_1157-21272.jpg?t=st=1652688461~exp=1652689061~hmac=0bda2356cdb596464df95cbf945609dea9476f238a886dba9bf4259a1eccc3ea&w=740"
    },

    {
        name: "Gala Jungle  ",
        address: "Kyla Olsen Ap #651-8679 Sodales Av. Tamuning PA 10855",
        ph: "(314) 244-6306",
        date: "June 20, 2022",
        price: "54$",
        rating: "5",
        image: "https://img.freepik.com/free-photo/cute-attractive-stylish-smiling-woman-walking-city-street-pink-coat-spring-fashion-trend-holding-purse-elegant-style_285396-2539.jpg?t=st=1652688461~exp=1652689061~hmac=c7731481798813d4b299af0ac01e07d1566dd46d11a65e8b669dbaf45194b98c&w=740"
    },

    {
        name: "Gig Glory  ",
        address: "Forrest Ray 191-103 Integer Rd. Corona New Mexico 08219",
        ph: "(947) 278-5929",
        date: "September 21, 2023",
        price: "65$",
        rating: "5",
        image: "https://img.freepik.com/free-photo/three-attractive-african-american-woman-brown-tunic-dress-posed-clothes-store-it-s-time-shopping_627829-695.jpg?t=st=1652688648~exp=1652689248~hmac=0198e7f24e5c20b0272f159876f6a875d795518415232f9dfe08dde673169e3e&w=740"
    },

    {
        name: "Midsummer Splendour  ",
        address: "Hiroko Potter P.O. Box 887 2508 Dolor. Av. Muskegon KY 12482",
        ph: "(684) 579-1879",
        date: "July 10, 2022",
        price: "34$",
        rating: "4",
        image: "https://img.freepik.com/free-photo/group-beautiful-girls-boys-pastel-wall_155003-10578.jpg?t=st=1652688727~exp=1652689327~hmac=de4bbe4255ed9cae19fcd1cd0d909a147eea7798acd92ea4ece27cb32118abb2&w=740"
    },
]
export default Data;